import { Routes, Route } from "react-router-dom";
import StaffProfileHub from "./StaffProfileHub";
import StaffProfileSettings from "./StaffProfileSettings";

export default function StaffProfile() {
  return (
    <Routes>
      <Route index element={<StaffProfileHub />} />
      <Route path="settings" element={<StaffProfileSettings />} />
    </Routes>
  );
}
